import { HttpClient } from '@angular/common/http';
import { Injectable, inject, isDevMode } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import {
  Translation,
  TranslocoLoader,
  TranslocoService,
  provideTransloco,
  provideTranslocoMissingHandler,
} from '@jsverse/transloco';
import { LANGUAGE_STORAGE_KEY } from '@shared/constants/storage-keys.const';
import { isAppLanguageCode } from '@shared/constants/app-languages.const';
import { readStorageItemSync } from '@shared/storage/web-storage.service';
import { SafeMissingTranslationHandler } from './safe-missing-translation.handler';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly http = inject(HttpClient);
  public getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

const storedLanguage = readStorageItemSync(LANGUAGE_STORAGE_KEY);

export const translocoConfig = [
  provideTransloco({
    config: {
      availableLangs: ['es', 'en', 'ca'],
      defaultLang: isAppLanguageCode(storedLanguage) ? storedLanguage : 'es',
      fallbackLang: 'es',
      reRenderOnLangChange: true,
      prodMode: !isDevMode(),
    },
    loader: TranslocoHttpLoader,
  }),
  provideTranslocoMissingHandler(SafeMissingTranslationHandler),
];

/** Ensures synchronous error notifications can resolve the active language during app bootstrap. */
export async function preloadActiveTranslation(transloco: TranslocoService): Promise<void> {
  await firstValueFrom(transloco.load(transloco.getActiveLang()));
}
